<template>

    <el-drawer
      title=""
      v-model="visible"
      @close="hide"
      header-class="se-help-header"
      :size="size"
      direction="rtl"
    >
      <template #header>
        <div>
          Learn More<br>
          <span class="fs85">Send questions to Income_Calculator@FannieMae.com</span>
        </div>
      </template>

      <div class="ml-3 mr-3">
        <slot></slot>
      </div>
    </el-drawer>

</template>
<script>
import { defineComponent } from 'vue';

import {ElDrawer} from 'element-plus'


export default defineComponent({
  emits: ['open', 'close', 'update:visible'],

  components: {
    ElDrawer,
  },

  props: {
    visible: Boolean,
    title: {
      type: String,
      default: "Learn More"
    },
    size: {
      type: String,
      default: "40%"
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    }
  },

  methods: {
    hide() {
      this.$emit('update:visible', false);
    }
  },
});
</script>

<style>
.se-help-header {
  height: 72px;
  color: white !important;
  background: #085280 !important;
  padding: 10px 10px 1rem 15px !important;
  margin-bottom: 0.5rem !important;
}
.fs85 {
  font-size:.85rem;
}

</style>
